// extracted by mini-css-extract-plugin
export default {"container":"foodItem_container__r6U4X","name":"foodItem_name__35gOP","description":"foodItem_description__Pcvcu","price":"foodItem_price__r9dy2"};